import { QueryClient, provideAngularQuery } from '@tanstack/angular-query-experimental';

export function provideQueryClient() {
  return provideAngularQuery(new QueryClient());
}
